import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import * as l from "react";

function i(e, t) {
  return e === t && (e !== 0 || 1 / e === 1 / t) || e !== e && t !== t;
}

var d = typeof Object.is == "function" ? Object.is : i,
    u = l.useState,
    h = l.useEffect,
    f = l.useLayoutEffect,
    p = l.useDebugValue;

var S = !1,
    _ = !1;

function y(e, t, c) {
  var a = t(),
      _u = u({
    inst: {
      value: a,
      getSnapshot: t
    }
  }),
      _u2 = _slicedToArray(_u, 2),
      n = _u2[0].inst,
      o = _u2[1];

  return f(function () {
    n.value = a, n.getSnapshot = t, r(n) && o({
      inst: n
    });
  }, [e, a, t]), h(function () {
    return r(n) && o({
      inst: n
    }), e(function () {
      r(n) && o({
        inst: n
      });
    });
  }, [e]), p(a), a;
}

function r(e) {
  var t = e.getSnapshot,
      c = e.value;

  try {
    var a = t();
    return !d(c, a);
  } catch (_unused) {
    return !0;
  }
}

export { y as useSyncExternalStore };